export default __webpack_public_path__ + "static/media/HomeSideImage.c3479cf3.jpeg";